module.exports = __webpack_public_path__ + "img/card-select-type-gift-icon.0133725a.svg";